// checkin chckout enum
export const PunchEnum = {
  checkin: "checkin",
  checkout: "checkout"
};
